import moment from "moment";
// import _ from "lodash";
import axios from "axios";
import {
  chunkPromise,
  PromiseFlavor,
  ChunkPromiseCallbackForceStopError,
} from "chunk-promise";
import { generateDocName } from "./functions";

var ObjectID = require("bson-objectid");

export function deleteDoc() {
  let docId = this.state.deleteId;
  document.querySelector(`.id-${docId}`).classList.add("deleting");

  this.setState(
    {
      deleting: true,
    },
    () => {
      // Delete via API (will automatically move to trash)
      axios
        .delete(`/api/documents/${docId}`, {
          params: { collection: this.props.collection }
        })
        .then(() => {
          this.closeDialog();
          this.setState({
            deleting: false,
            documents: [
              ...this.state.documents.filter(
                (doc) => doc._id.toString() !== docId
              ),
            ],
          });
          if (window.location.pathname === "/") {
            // this.displayDocs(null, true);
          } else {
            this.props.history.push(`/`);
          }
          this.showNotification(
            "success",
            `SOW [${this.state.deleteTitle}] deleted!`
          );
        })
        .catch((err) => {
          console.error(err);
          deleteFailed();
        });
    }
  );

  const deleteFailed = () => {
    this.setState({
      deleting: false,
    });
    document.querySelector(`.id-${docId}`).classList.remove("deleting");
    this.showNotification("error", "Failed to delete SOW!");
  };
}

export async function getNewDocNumber() {
  try {
    const response = await axios.get("/api/documents/next-number", {
      params: { collection: this.props.collection }
    });
    return response.data.nextDocNum;
  } catch (error) {
    console.error("Error getting next doc number:", error);
    return 1; // Default to 1 if error
  }
}

export async function cloneDoc(e, docId, version, title, batch) {
  this.setState({
    query: "",
    cloning: true,
  });
  e?.preventDefault();

  try {
    // Use API to clone document
    const response = await axios.post(`/api/documents/${docId}/clone`, {
      collection: this.props.collection,
      version,
      batch,
      userId: this.context.user.id,
    });

    this.setState({
      cloning: false,
    });

    if (window.location.pathname === "/") {
      this.displayDocs(null, true);
    } else {
      this.props.history.push(`/${response.data.insertedId}`);
    }

    if (version) {
      this.showNotification(
        "success",
        `New version of [${title}] added!`
      );
    } else {
      this.showNotification("success", `SOW [${title}] cloned!`);
    }
  } catch (err) {
    console.error(err);
    this.setState({
      cloning: false,
    });
    this.showNotification("error", "Failed to clone document!");
  }
}

export function batchCloneDoc(arrayDoc, originId) {
  this.setState({ batchCloning: true });

  if (arrayDoc.length) {
    let promiseArr = [];

    arrayDoc.forEach((doc) => {
      promiseArr.push(() => this.cloneDoc(null, originId, null, null, doc));
    });

    chunkPromise(promiseArr, {
      concurrent: 1,
      promiseFlavor: PromiseFlavor.PromiseAll,
      callback: async (chunkResults, index) => {
        if (!this.state.openBatch) {
          throw new ChunkPromiseCallbackForceStopError(
            `Callback force stop at chunk index ${index}`
          );
        }

        let batchProgress = (index / arrayDoc.length) * 100;
        this.setState({ batchProgress });
      },
    })
      .then((res) => {
        this.showNotification("success", "Batch Clone Success!");
        this.setState({ batchCloning: false });
        this.closeBatchDialog();
      })
      .catch((err) => {
        console.log("Batch Clone Failed!", err);
        this.showNotification("error", "Batch Clone Failed!");
      });
  }
}
